import { BrokerExtensions } from "@primaria/plugins-core";
import { BrokerDisposableHandler } from "@uxland/primary-shell";
import { SetUpFiltersHandler } from "./handler";
import { SetUpFiltersCommand } from "./request";

let request: BrokerDisposableHandler;

export const bootstrapSetUpFilter = (broker: BrokerExtensions) => {
  request = broker.registerRequest(SetUpFiltersCommand, SetUpFiltersHandler);
};

export const teardownSetUpFilter = () => {
  request?.dispose();
};
